<template>
  <div class="draw_scroll" ref="scrollWrap">
    <div class="draw_list"
         v-infinite-scroll="loadMore"
         infinite-scroll-immediate="false"
         v-if="!isLogin||draw_list.length==0">
      <div class="draw_list_item"
           v-for="(item,index) in sampleSysList"
           :key="index">
        <div class="text">
          <div class="title flex jb">
            <div class="info flex ac">
              <img src="./img/viggle.png" class="avatar"/>
              <div>
                <p style="margin-bottom: 3px">
                  <span class="topic">Viggle</span>
                  <span class="tag">AI机器人</span>
                </p>
                <p>
                  <span class="time">{{ item.add_time }}</span>
                </p>
              </div>
            </div>
            <div class="flex ac">
              <p class="delete flex ac"
                 @click="sample_btn('del')">
                <i class="el-icon-delete"></i><span>删除</span>
              </p>
              <p class="delete flex ac"
                 @click="downloadVideo('sample')">
                <i class="el-icon-download"></i><span>下载</span>
              </p>
              <p class="delete flex ac"
                 @click="sample_btn('put')">
                <i class="el-icon-position" style="font-size: 14px"></i><span>推荐广场</span>
              </p>
            </div>
          </div>
          <div style="margin: 10px 0 0 0;" class="success_shouVideo">
            <video controls controlslist="nodownload"
                   style="background-color:black;"
                   :poster="item.cover_url"
                   preload="none"
                   :src="item.video_url"
                   @play="handlePlay(index)"
                   ref="videoPlayers">
            </video>

          </div>
        </div>
      </div>
    </div>

    <div class="draw_list"
         v-infinite-scroll="loadMore"
         :infinite-scroll-disabled="loading">
      <div class="draw_list_item"
           v-for="(item,index) in draw_list"
           :key="index">
        <div class="text">
          <div class="title flex jb">
            <div class="info flex ac">
              <img src="./img/viggle.png" class="avatar"/>
              <div>
                <p style="margin-bottom: 3px">
                  <span class="topic">Viggle</span>
                  <span class="tag">专业版</span>
                </p>
                <p>
                  <span class="time">{{ item.add_time }}</span>
                </p>
              </div>
            </div>
            <div class="top_right">
              <div @click="deleteVideo(index, item)">
                <i class="el-icon-delete"></i>删除
              </div>
              <div @click="downloadVideo(item)"
                   v-if="item.status == 2 "
                   style="margin-left: 5px" type="text">
                <i class="el-icon-download" style="font-size: 14px"></i>下载
              </div>
              <div v-if="item.status == 2">
                <div style="margin-left: 5px" v-if="item.is_public==0||item.is_public==null"
                     @click="recommend(item.id,index)">
                  <i class="el-icon-position"></i> 推荐广场
                </div>
                <div style="margin-left: 5px" v-else>
                  <i class="el-icon-position"></i> 已推荐到广场
                </div>
              </div>
            </div>
          </div>

          <div class="create_error" v-loading="item.regenLoading > 0 "
               v-if="item.status == 3">
            <!-- 绘画 失败 -->
            <img class="error_icon"
                 src="../../views/img/image_error.png"
                 alt="">
            <div class="error_text">很遗憾，生成失败 !</div>
            <div class="error_btn"
                 v-if="item.retry_num>=3 || item.is_retry!=0"
                 @click="showDefeatPopup">查看失败原因
            </div>
            <div class="error_new_btn"
                 v-if="item.retry_num<3 && item.is_retry==0"
                 @click="error_new_fn(item.id,index)">
              点此重新生成<br/><span class="err_succ_text">（成功率90%以上）</span>
            </div>
            <div class="err_new_tip" v-if="item.show_error">
              失败原因： <span style="color:red;">{{item.show_error}}</span>
            </div>
            <div class="err_new_tip" v-else>
              涉政、涉黄等请勿提交，会封号。其他问题，请联系<span class="err_tokf" @click="toKf">在线客服</span>
            </div>
          </div>
          <template v-if="item.status < 2 ||(item.status == 2 && item.local_video_url === null)">
            <!-- 绘画 中 -->
            <div class="detail_loading msg-item-content">
              <circleloading></circleloading>
              <div class="loading_text">
                正在全力生成视频中，请稍等...
              </div>
            </div>
          </template>
          <div v-if="item.status == 2 && item.local_video_url !== null" style="padding: 10px 0 0 0 ;">
            <div class="success_shouVideo">
              <video controlslist="nodownload"
                  role="application" controls
                  :poster="item.cover_url!=null?item.cover_url:''"
                  :preload="item.cover_url!=null?'none':'auto'" v-loading="true"
                  :src="item.local_video_url"
                  ref="videoPlayers"></video>
              <div v-if="item.img_url !=null || item.img_url !=''" class="success_img"
                   :style="item.img_url ==null || item.img_url ==''?'display:none;':'display:;'">
                <img :src="item.img_url" alt="" class="xianshi">
                <div class="success_imgdel">
                  <div style="display: flex;align-items: flex-end;">
                            <span
                                style="background: #5865f2a8;border-radius: 3px;margin:  2px;padding: 0 4px;color: white">原图</span>
                  </div>
                  <div style="display: flex;flex-direction: column;padding: 2px 2px 0 0 ;">
                    <i class="el-icon-close yichang" @click="item.img_url = ''"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <popup ref="defeatPopup"
           type="center"
           @close="defeatPopClose">
      <div class="defeat_popup">
        <div class="popup_title">失败原因如下</div>
        <div class="popup_content">
          <div class="content_item">
            <div class="item_question">问：为什么Runway会比较慢？</div>
            <div class="item_answer">
              答：因为Runway与其他视频软件不同，本身为Ai绘制通常仅需约几分钟完成，算下来速度相当快！
            </div>
          </div>
          <div class="content_item">
            <div class="item_question">问：为什么绘制视频会提示失败？</div>
            <div class="item_answer">
              答：因为Runway绘制视频全部为Ai原创，可能会出现违规低俗内容，这些图片会被系统自动过滤删除，与您无关！
            </div>
          </div>
        </div>
        <button class="close_btn"
                @click="defeatPopClose">好的，我知道了
        </button>
      </div>
    </popup>
    <!-- 推荐到广场 -->
    <Recommend v-if="current_draw&&show_recommend_popup"
               :draw_item="current_draw"
               @close="recommendCallBack"
               ref="recommend"></Recommend>
    <!-- 分享 -->
    <ShareDraw v-if="current_draw&&show_sharedraw_popup"
               :draw_item="current_draw"
               @close="show_sharedraw_popup=false"
               ref="ShareDraw"></ShareDraw>


    <!-- 反馈弹窗 -->
    <FeedBack v-if="current_draw&&show_feedback_popup"
              :draw_item="current_draw"
              @close="show_feedback_popup=false"
              ref="feedback"></FeedBack>

    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
  </div>
</template>
<script type="text/ecmascript-6">
import popup from "COMPONENTS/Popup.vue"
import circleloading from "COMPONENTS/CircleLoading.vue"
import FeedBack from '@/components/FeedBack.vue'
import Recommend from '@/components/Recommend.vue'
import ShareDraw from '@/components/ShareDraw.vue'
import drawCateEdit from '@/components/DrawCateEdit'
import TipsWords from '@/components/TipsWords'
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import utils from "@/utils";

export default {
  components: {popup, circleloading, FeedBack, Recommend, ShareDraw, drawCateEdit, TipsWords, faceVerifyPopup},
  data() {
    return {
      //显示用户反馈
      show_feedback_popup: false,
      //显示推荐到广场
      show_recommend_popup: false,
      //显示分享弹窗
      show_sharedraw_popup: false,
      current_draw: null,//当前选中的记录
      draw_list: [],
      noMore: false, // 是否还有数据
      loading: false, // 正在请求数据
      max_mj_id: 0, // 最小的ID
      checkIds: [], // 生成中的需要检测的ID
      timer: null,
      sampleSysList: [], // 系统样例
      sampleUserList: [], // 用户样例
      sampleTimer: null,
      view_img_url: "",
      page: 1,

    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    }
  },
  created() {
    this.sampleUserList = JSON.parse(localStorage.getItem('sampleUserList') || "[]")

    this.fetchDataList()
    // this.fettchSampleList()
  },
  methods: {
    error_new_fn(id, index) {
      //{params:{id}}
      this.draw_list[index].regenLoading = 1
      this.$forceUpdate()
      this.$http.post('/front/aivideo/retry/', {id}).then(res => {
        this.draw_list[index].regenLoading = 0
        if (res.status == 200) {
          this.$message.success('重新生成创建成功')
          this.scrollToTop()
          this.draw_list[index].is_retry = 1
          this.draw_list.unshift(res.data.video)
          this.checkIds.push(res.data.video.id)
          this.fetchMsg()
        } else {
          let message = res.message;
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "expired_gift_score") {
            // 队列已满
            this.$confirm('您的积分已过期，如需继续使用该功能请购买积分或升级套餐', '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_face_verify") {
            // 实名认证
            this.$refs.faceVerifyPopup.show()
            return
          } else if (message == 'retry_num_max') {
            message = '已超出最大重试次数'
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
          })
        }
      }).catch(res => {
        this.draw_list[index].regenLoading = 0
        let message = res.message;
        if (message == "vip_expire") {
          // VIP 过期了
          this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
            this.$router.push('/member')
          }).catch(() => {

          });
          return
        } else if (message == "no_open_vip") {
          // 未开通 VIP
          this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
            this.$router.push('/member')
          }).catch(() => {

          });
          return
        } else if (message == "no_gift_score") {
          // 积分不足
          this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
            this.$router.push('/member')
          }).catch(() => {

          });
          return
        } else if (message == "expired_gift_score") {
          // 队列已满
          this.$confirm('您的积分已过期，如需继续使用该功能请购买积分或升级套餐', '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push('/member')
          }).catch(() => {

          });
          return
        } else if (message == "upgradevip") {
          // 队列已满
          this.$confirm(res.data.msg, '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
            this.$router.push('/member')
          }).catch(() => {

          });
          return
        } else if (message == "no_face_verify") {
          // 实名认证
          this.$refs.faceVerifyPopup.show()
          return
        } else if (message == 'retry_num_max') {
          message = '已超出最大重试次数'
        }
        if (message.indexOf("您提问的内容包含违禁词") > -1) {
          message = "内容可能违反国家政策，请重新输入";
        }
        this.$confirm(message, '提示', {
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
        })
      })
    },
    toKf() {
      utils.tokf()

      // window.open('/linkus')
    },
    fettchSampleList() {
      // 获取样例数据
      let bd_vid = this.getCache("bd_vid") || ""
      let qhclickid = this.getCache("qhclickid") || ""
      let sourceid = this.getCache("sourceid") || ""

      let ad_account_id = this.getCache("ad_account_id") || 0


      this.$http.get('/front/aivideo/sample/?platform=1', {
        params: {
          max_mj_id: this.max_mj_id,
          soft: 3,
          page: this.page,
          size: 10,
        }
      }).then((res) => {
        let _list = res.data.item_list
        this.noMore = false
        this.loading = false
        this.sampleSelectList = _list.slice(_list.length - 20, _list.length)
        if (this.sampleUserList.length > 0) {
          this.sampleSysList = this.sampleUserList
        } else {
          this.sampleSysList = this.sampleSysList.concat(_list)
        }
      })
    },

    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)
          this.$store.commit('setShowLogin', true)
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }
    },

    loadMore() {
      // 加载更多数据
      this.noMore = true
      this.loading = true
      if (this.isLogin) {
        // 登录请求样例
        this.page++;
        this.fetchDataList()
      } else {
        // 未登录请求样例
        // this.pageType = false
        if (!(this.sampleSysList.length % 10 === 0)) {
          this.$message.warning('样例已全部加载')
          return
        }
        this.page = this.page + 1
        if (this.page == 4) {
          this.$message.warning('样例已全部加载')
          return;
        }
        if (this.page > 4) {
          return
        }
        this.fettchSampleList()
      }
    },
    fetchDataList() {
      // 对话内容
      this.loading = true
      this.$http.get(`/front/aivideo/user/video/`, {
        params: {
          page: this.page,
          size: 10,
          soft: 3
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.item_list.length > 0) {
            if (this.max_mj_id == 0) {
              res.data.item_list.forEach(e => {
                if (e.status <= 1 || (e.status == 2 && e.local_video_url === null)) {
                  this.checkIds.push(e.id)
                }
              })
              this.fetchMsg()
            }
            this.max_mj_id = res.data.item_list[res.data.item_list.length - 1].draw_id
            this.draw_list = this.draw_list.concat(res.data.item_list)
            this.draw_list.forEach(item => {
              if (item.regenLoading != 1) {
                item.regenLoading = 0
              }
            })
            // this.draw_list[0].status = 3
            // this.draw_list[0].show_error = 1
            // this.draw_list[0].is_retry = 0
            // this.draw_list[0].retry_num = 1
          } else {
            this.noMore = true
            if (this.max_mj_id == 0) {
              this.fettchSampleList()
            }
          }
        } else {
          this.fettchSampleList()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    submitQuestion(data, parent_msg_code, i) {
      if (this.sending) {
        this.$message({
          message: '正在任务，不要重复提交，请稍后！',
          type: 'waring'
        });
        return
      }
      this.sending = true;
      // 提交问题
      data.source = "pc";
      this.$http.get(`/front/aivideo/user/video/?soft=1`, {params: {max_mj_id: this.max_mj_id}}).then(res => {
        if (res.status == 200) {
          this.inputVal = "";
          this.draw_list.unshift(res.data.draw);
          this.scrollToTop();
          // 发送消息
          this.checkIds.push(res.data.draw.draw_id)

          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });

          this.fetchMsg();
        } else {

          let message = res.message;
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
          })
        }
      }).finally(() => {
        this.sending = false;
      })
    },
    fetchMsg() {
      if (this.checkIds.length == 0) {
        return
      }
      if (this.timer) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        this.$http.post('/front/aivideo/viggle/statuslist/', {ids: this.checkIds}).then((res) => {
          if (res.status == 200) {
            let item_list = res.data;
            let draw_id = 0;
            item_list.forEach(e => {
              draw_id = e.id
              let item = this.draw_list.filter((obj) => obj.id == draw_id)[0];

              item.status = e.status
              item.is_public = 0
              let num = parseInt(Math.random() * 10);
              if (item.progress + num > 100) {
                item.progress = 100
              } else {
                item.progress += num
              }
              // item.img_url = e.img_url;
              if (e.status > 2) {
                // 删除生成成功或失败的
                item.show_error = e.show_error
                if(e.show_error){
                  this.$message.error(e.show_error)
                }
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
              }
              if (e.status == 2 && e.local_video_url != null) {
                // 生成成功 并下载本地
                this.checkIds = this.checkIds.filter(i => i !== draw_id)

                item.local_video_url = e.local_video_url
                item.cover_url = e.cover_url
                item.img_url = e.img_url

                this.scrollToTop();
                // 创作成功检测是否弹出挽留弹窗
                utils.checkContinuePop(this.$store.state.userInfo)
              }
              if (e.status === 3) {
                // 失败
                console.log('shibai')
                console.log(e)
                this.draw_list.forEach((_list, num) => {
                  if (_list.id == e.id) {
                    this.draw_list[num] = e
                  }
                })
              }
            })
          }
          if (this.checkIds.length == 0) {
            clearInterval(this.timer);
          }
        }).catch((res) => {
          clearInterval(this.timer);
        })
      }, 3000)
    },

    scrollToTop() {
      this.$nextTick(() => {
        let scrollWrap = this.$refs.scrollWrap;
        scrollWrap.scrollTop = 0;
      })
    },
    delete_draw_list(id, index) {
      // 删除
      this.$confirm('确定删除该创作记录吗，删除后不可恢复？', '提示', {
        type: 'warning',
        customClass: 'confirm_box'
      }).then(() => {
        this.$http.delete(`/front/aimj/draw/${id}/`).then((res) => {
          this.draw_list.splice(index, 1)
        })
      })

    },
    showDefeatPopup() {
      this.$refs.defeatPopup.show();
    },
    defeatPopClose() {
      this.$refs.defeatPopup.close();
    },

    sample_btn(name) {
      if (!this.checkLogin()) {
        return
      }

      if (name == 'del') {
        this.$message({
          message: '样例数据不能删除！请创作后重试。',
          type: 'warning'
        });
      } else {
        this.$message({
          message: '样例数据不能推荐到广场！请创作后重试。',
          type: 'warning'
        });
      }
    },
    deleteVideo(index, msg) {
      this.$confirm('确定删除该创作记录吗，删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/front/aivideo/${msg.id}/`).then(res => {
          if (res.status == '200') {
            this.$message.success('删除成功')
            this.draw_list.splice(index, 1)
          }
        })
      }).catch(() => {
      });
    },
    recommend(video_id, index) {
      if (!this.checkLogin()) {
        return
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/member')
        })
        return false
      }
      this.$http.patch('/front/aivideo/user/video/' + video_id + '/', {
        action: "public",
        data: {sys_cate_id: 1}
      }).then(res => {
        if (res.status === '200') {
          this.$message({
            message: '推荐成功，请等待审核！',
            type: 'success'
          });
          this.draw_list[index].is_public = 1

        } else {
          this.$message.error(res.message)
        }
      }).catch(res => {
        this.$message({
          message: res.message,
          type: 'error'
        });
      }).finally(() => {
        this.sendLoading = false
      })
    },
    // 视频播放暂停 仅一个视频播放
    handlePlay(index) {
      this.$nextTick(() => {
        const videoPlayers = this.$refs.videoPlayers;
        videoPlayers.forEach((item, num) => {
          if (num != index) {
            videoPlayers[num].pause();
          } else {
            videoPlayers[num].play();
          }
        })
      });
    },
    //用户视频下载
    downloadVideo(is_video,) {
      // return
      if(is_video=='sample'){
        this.$message.warning('当前样例不可下载，请生成后重试！')
        return
      }
      this.$http.get(`/front/aivideo/download/${is_video.id}/?soft=1`,).then(res => {
        if (res.status == '200') {
          window.location.href = res.data.url
        } else {
          let message = res.message;
          utils.createErrTip(message)
        }
      }).catch(err=>{
        let message = err.message;
        utils.createErrTip(message)
      }).finally(() => {
        this.loading = false
      })

    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = null;
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.draw_scroll {
  background-color: #313338;
  height: calc(100% - 15px);
  overflow-y: auto;
  color: #fff;

  &::-webkit-scrollbar {
    margin-left: 5px !important;
    display: block !important;
    width: 6px !important;
  }

  &::-webkit-scrollbar-thumb {
    height: 30px !important;
    background-color: #777 !important;
    border-radius: 10px !important;
  }

  .draw_list {
    overflow: hidden;
    width: 100%;
    position: relative;

    .draw_list_item {
      padding-bottom: 5px;
      background: #403d38;
      border-left: 2px solid #f0b132;
      margin: 10px 0;

      .avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 7px;
        cursor: pointer;
      }

      .text {
        padding: 10px;
        overflow: hidden;
        word-break: break-all;
        white-space: normal;
        line-height: 20px;

        .title {
          font-size: 12px;
          margin-bottom: 10px;

          .info {

            .topic {
              font-size: 14px;
              margin-right: 10px;

            }

            .tag {
              display: inline-block;
              //line-height: 24px;
              background-color: #5865f280;
              color: #fff;
              font-size: 12px;
              padding: 0 5px;
              border-radius: 4px;
              white-space: nowrap;
            }

            .time {
              color: #707070;
            }
          }

          .more_btn {
            width: 36px;
            height: 24px;
            border-radius: 4px;
            color: #fff;
            font-size: 16px;
            background-color: #1e1f22;
          }

          .delete {
            cursor: pointer;
            margin-left: 8px;
            color: #949ba4;

            img {
              width: 20px;
              height: 20px;
              margin-top: -2px;

              &.share {
                width: 16px;
                height: 16px;
              }
            }
          }
        }

        .top_right {
          display: flex;
          align-items: center;
          white-space: nowrap;
          margin-left: 8px;
          color: #949ba4;
          cursor: pointer;

          div:hover {
            color: #fff;
          }

          .el-icon-delete {
            font-size: 14px;
            margin-right: 3px;
          }
        }

        .desc {
          p {
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            line-clamp: 3;
          }

          .en {
            padding-top: 10px;
            margin-top: 10px;
            color: #999168;
            border-top: 1px solid #555041;
          }
        }
      }

      .big_img {
        margin-top: 10px;

        .el-image {
          width: 200px;
        }
      }

      .options {
        .options_list {
          margin-top: 10px;

          .tips_icon {
            width: 14px;
            height: 14px;
            opacity: 0.5;
          }

          span {
            font-size: 13px;
            width: 58px;
            height: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            background: #4e5058;
            margin-left: 8px;
            border-radius: 3px;
            cursor: pointer;

            img {
              width: 18px;
              height: 18px;
            }

            &:hover {
              background: #6e717c;
            }

            &.span {
              width: 100px;

              img {
                margin-right: 5px;
              }
            }

            &.span2 {
              width: 40px;
            }
          }

          //
          .redraw {
            img {
              height: 20px;
              // margin-top: 5px;
            }

            line-height: 32px;
          }

          .btn {

            &:not(:last-child) {
              margin-right: 0px;
            }

            &.loading {
              opacity: 0.6;

              svg {
                margin-top: -4px;
                vertical-align: middle;
                margin-right: 4px;
                animation: rotate 2s linear infinite;
              }
            }

            &.redraw2 {
              background-color: #f5f6fb;

              img {
                height: 30px;
              }
            }

            &.disabled {
              cursor: not-allowed;
              background-color: #ddd;
              color: #666;
            }
          }

          //
        }
      }
    }
  }
}

.tooltips_text {
  font-size: 14px;
  line-height: 1.7;
}

.create_error {
  width: 220px;
  height: 230px;
  padding: 0 10px;
  background-color: #fff;
  border-radius: 4px;
  padding-top: 28px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;

  .error_new_btn {
    color: #56b15b;

    .err_succ_text {
      color: #ccc;
    }
  }

  .err_new_tip {
    color: #ccc;
    margin-top: 20px;

    .err_tokf {
      color: red;
    }
  }

  .error_icon {
    display: block;
    width: 35px;
    margin: 0 auto;
  }

  .error_text {
    color: #ccc;
    line-height: 34px;
  }

  .error_btn {
    display: inline-block;
    cursor: pointer;
    color: #ffab46;
    padding-top: 15px;
  }
}

.success_shouVideo {
  position: relative;
  width: 100%;
  height: 200px;
  background-color: #080707;

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%; /* 设置视频宽度为父容器的100% */
    height: 100%; /* 保持视频的宽高比 */
  }

  .success_img {
    position: absolute;
    display: inline-block;
    top: 5px;
    right: 5px;
    border: 1px solid #FFF;
    width: 85px;

    img {
      display: block;
      width: 85px; /* 根据需要调整图片宽度 */
      height: auto;
      cursor: pointer;
    }

    img:hover .success_imgdel {
      position: absolute;
      top: 0; /* 调整图标距离顶部的距离 */
      right: 0; /* 调整图标距离右侧的距离 */
      border-radius: 50%; /* 使图标背景为圆形 */
      font-size: 18px; /* 根据需要调整图标字体大小 */
      color: #333; /* 图标颜色 */
      cursor: pointer;
      //display: none;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 100%;
    }

    .success_imgdel {
      position: absolute;
      top: 0; /* 调整图标距离顶部的距离 */
      right: 0; /* 调整图标距离右侧的距离 */
      border-radius: 50%; /* 使图标背景为圆形 */
      font-size: 18px; /* 根据需要调整图标字体大小 */
      color: #333; /* 图标颜色 */
      cursor: pointer;
      //display: none;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 100%;

      span {
        font-size: 12px;
      }

      i {
        font-size: 12px;
        background-color: #fff;
        border-radius: 50%;
      }
    }

    .success_imgdel:hover {
      color: white;

      i {
        font-size: 12px;
        background-color: #2b2d31;
        border-radius: 50%;
      }
    }

  }
}

.defeat_popup {
  width: 360px;
  padding: 0 30px 36px;
  background-color: #fff;
  border-radius: 10px;

  .popup_title {
    font-size: 16px;
    font-weight: bold;
    line-height: 60px;
    text-align: center;
    color: black;
  }

  .popup_content {
    padding-bottom: 10px;

    .content_item {
      padding-bottom: 18px;
      font-size: 13px;
      line-height: 25px;

      .item_answer {
        white-space: wrap;
        color: #999;
      }

      .item_question {
        width: 100%;
        white-space: wrap;
        color: #000;
      }
    }
  }

  .close_btn {
    width: 240px;
    height: 50px;
    border: none;
    border-radius: 5px;
    background-color: #5865f2;
    color: #fff;
    font-size: 15px;
    display: block;
    margin: 0 auto;
  }
}

.msg-item-content {
  font-size: 13px;
  line-height: 20px;
  padding-top: 5px;

  &.detail_loading {
    .remove_icon {
      // display: none;
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("../img/update_close.png");
      background-color: rgba(100, 100, 100, 0.6);
      cursor: pointer;
      border-radius: 3px;
    }

    .loading_text {
      padding-left: 12px;
      color: #f0b132;
    }
  }
}

.creating_progress {
  margin-top: 15px;
  display: flex;
  align-items: center;
  width: 360px;

  .progress_bar {
    flex-grow: 1;
    height: 10px;
    border-radius: 5px;
    background-color: #dbefe4;
    margin-right: 6px;

    .progress_line {
      height: 100%;
      background-color: #f0b132;
      border-radius: 5px;
      transition: width 0.3s linear;
    }
  }

  .progress_percent {
    font-size: 12px;
    line-height: 1;
    color: #f0b132;
    white-space: nowrap;
  }
}

.msg_img_wrap {
  max-width: 400px;
  position: relative;
  overflow: hidden;
  display: inline-block;
  // border-radius:5px;
  &:hover {
    .img_footer {
      bottom: 0;
    }
  }

  .msg_img_ele {
    display: block;
    width: 100%;
    cursor: pointer;
  }

  .img_footer {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: -40px;
    height: 40px;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: space-around;
    transition: bottom 0.3s;

    .footer_item {
      cursor: pointer;

      .footer_icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-right: 5px;
        background-size: 100% 100%;

        &.download {
          background-image: url("../img/download.png");
        }

        &.preview {
          background-image: url("../img/preview_img.png");
        }

        &.delete {
          background-image: url("../img/remove.png");
        }
      }

      span {
        vertical-align: middle;
        display: inline-block;
        font-size: 14px;
        color: #fff;
      }
    }
  }

  .look_img {
    //display: none;
    //opacity: 0;
    cursor: pointer;
    width: 75px;
    height: 28px;
    position: absolute;
    top: 10px;
    right: 10px;
    border: rgba(88, 101, 242, 0.8) solid 2px;
    background-color: rgba(88, 101, 242, 0.533);
    border-radius: 6px;
    color: white;
    font-size: 12px;
    box-sizing: border-box;
    line-height: 24px;
    text-align: center;
  }
}

.more_list {
  .operate_item {
    height: 28px;
    font-size: 14px;
    color: #949ba4;

    img {
      width: 20px;
      height: 20px;
      margin-top: -2px;
      margin-right: 4px;

      &.share {
        width: 14px;
        height: 14px;
        margin-left: 3px;
        margin-right: 6px;
      }
    }
  }
}
</style>